<template>
  <a-list
    class="list c-list"
    :loading="loading"
    itemLayout="horizontal"
    :pagination="pagination"
    :dataSource="results"
  >
    <list-cols-header
      slot="header"
      :headers="headers"
      :actions-cols="1"
      :col-spans="[24]"
      @sort="handleSort"
    />

    <a-list-item slot="renderItem" slot-scope="item">
      <a slot="actions">
        <a-button
          type="link"
          icon="message"
          @click="() => openDirectChat(item.id)"
        />
      </a>
      <a slot="actions">
        <router-link :to="`/admin/lektorzy/szczegoly/${item.id}/kalendarz/`">
          <a-button type="link" icon="calendar" />
        </router-link>
      </a>
      <a slot="actions">
        <a-dropdown :trigger="['click']">
          <a-button type="link" icon="more" class="ant-dropdown-link" />
          <a-menu slot="overlay">
            <a-menu-item>
              <router-link :to="`/admin/lektorzy/szczegoly/${item.id}/edytuj/`">
                edytuj profil lektora
              </router-link>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </a>
      <a-list-item-meta :description="item.languages.join(' | ')">
        <a slot="title">
          <router-link :to="`/admin/lektorzy/szczegoly/${item.id}/edytuj/`">
            <span>
              {{ item.full_name }}
            </span>
            <span v-if="!item.is_active" class="inactive-label">
              Konto dezaktywowane
            </span>
          </router-link>
        </a>
        <a-avatar slot="avatar" icon="user" :src="item.avatar" />
      </a-list-item-meta>
    </a-list-item>
  </a-list>
</template>

<script>
export default {
  queryModels: ['ordering'],
  props: {
    results: Array,
    pagination: {
      type: Object,
      required: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      headers: [
        {
          title: 'Imię i nazwisko lektora',
          sort: true,
          key: 'first_name'
        }
      ]
    }
  },
  methods: {
    handleSort(order) {
      this.ordering = order || undefined
    }
  }
}
</script>

<style lang="scss" scoped>
.inactive-label {
  position: relative;
  top: -2px;
  background-color: rgba(black, 0.04);
  color: rgba(black, 0.65);
  font-size: 11px;
  padding: 4px 8px;
  display: inline-block;
  border-radius: 8px;
  line-height: 1;
  font-weight: 400;
  margin-left: 4px;
}

.list {
  margin-top: 40px;
}
</style>
